"use client";

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";

//#region [Props]
type SearchParamsChangeListenerProps = {
  /** called when the query string changes after mount, not on mount */
  onChange: () => void;
};
//#endregion

//#region [Component]
/**
 * Lets a component react to query string changes without calling useSearchParams itself.
 * useSearchParams suspends while a page is prerendered (Cache Components), so calling it in a
 * provider would take the whole page out of the static HTML. Renders nothing - put it in
 * <Suspense fallback={null}>.
 */
export default function SearchParamsChangeListener(t0) {
  const $ = _c(6);
  const {
    onChange
  } = t0;
  const t1 = useSearchParams();
  let t2;
  if ($[0] !== t1) {
    t2 = t1.toString();
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const search = t2;
  const previous = useRef(search);
  let t3;
  let t4;
  if ($[2] !== onChange || $[3] !== search) {
    t3 = () => {
      if (search !== previous.current) {
        previous.current = search;
        onChange();
      }
    };
    t4 = [search, onChange];
    $[2] = onChange;
    $[3] = search;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  return null;
}
//#endregion